import { render, staticRenderFns } from "./TermsAgency.vue?vue&type=template&id=52354022&scoped=true&"
import script from "./TermsAgency.vue?vue&type=script&lang=js&"
export * from "./TermsAgency.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgency.vue?vue&type=style&index=0&id=52354022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52354022",
  null
  
)

export default component.exports